import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivateFn } from '@angular/router';
import { UserService } from '../services/user.service';
import { AuthService } from '../services/auth.service';
import { throwError } from 'rxjs';
import { AlertService, AlertType } from '../services/alert.service';
import { toSignal } from '@angular/core/rxjs-interop';

export const authGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const authService = inject(AuthService);
  const router = inject(Router);
  const alertService = inject(AlertService);
  const hasMenuEveryOne = localStorage.getItem('menuEveryoneCard') ? localStorage.getItem('menuEveryoneCard') : false;
  const hasMenuFacialTerms = localStorage.getItem('menuFacialTerms') ? localStorage.getItem('menuFacialTerms') : false;
  const isDependent = toSignal(authService.isDependent, { initialValue: false });
  const dependentRoutes = ['/dashboard-dependente', '/completar-dados', '/alterar-senha', '/dados-de-socio'];
  const useFanBase = authService.useFanBase;

  const currentUser = userService.currentUserValue ?? {};
  const token = authService.getToken() ?? '';

  if (token && authService.isTokenExpired(token)) {
    authService.logout(state.url);
    return throwError(() => new Error('Token expired'));
  }

  if (!hasMenuFacialTerms && state.url === '/termo-facial') {
    alertService.showAlert(AlertType.WARNING, 'Página não disponível.');
    router.navigate(['/']);
    return false;
  }

  if (!hasMenuEveryOne && state.url === '/cartao-todos') {
    alertService.showAlert(AlertType.WARNING, 'Página não disponível.');
    router.navigate(['/']);
    return false;
  }

  if (useFanBase && state.url === '/alterar-senha') {
    alertService.showAlert(AlertType.WARNING, 'Página não disponível.');
    router.navigate(['/']);
    return false;
  }

  if (isDependent() && !dependentRoutes.includes(state.url)) {
    router.navigate(['/']);
    return false;
  }

  if (Object.keys(currentUser)?.length && token) {
    return true;
  }

  authService.logout(state.url);
  return false;
};
